/**
 * AvatarSelection 스타일
 * @description 컴포넌트 토큰이 없어 시맨틱으로 조립한다. 링은 `border` 가 아니라 inset
 *   `box-shadow` 다 — 상태에 따라 1 → 2 로 굵어지는데 `border` 는 상자 크기에 더해져 누를
 *   때마다 아바타가 커진다. 체크 배지는 아바타 밖으로 2 만큼 나간다.
 */
import { cva } from "class-variance-authority";

/** 아바타 지름 md — 앱은 `size.control.xxxxl`(80) 을 쓴다. */
export const AVATAR_SELECTION_SIZE = 80;

/** 배지 지름 28 — `size.control`(24·32…) 과 `size.icon` 어디에도 없는 값이다. */
export const AVATAR_SELECTION_BADGE_SIZE = 28;

export const avatarSelectionStyles = {
  root: [
    "flex cursor-pointer flex-col items-center self-center",
    "gap-[var(--fw-space-gap-sm)] disabled:cursor-not-allowed",
    "focus-visible:outline-2 focus-visible:outline-offset-2",
    "focus-visible:outline-[var(--fw-color-border-focused)]",
  ].join(" "),
  /** 링과 배지의 기준 — 크기는 아바타를 따라간다. */
  frame: "relative block",
  image: "block rounded-[var(--fw-radius-full)] object-cover",
  ring: cva(
    "pointer-events-none absolute inset-0 rounded-[var(--fw-radius-full)]",
    {
      variants: {
        state: {
          disabled:
            "shadow-[inset_0_0_0_var(--fw-border-sm)_var(--fw-color-border-disabled)]",
          selected:
            "shadow-[inset_0_0_0_var(--fw-border-lg)_var(--fw-color-border-brand)]",
          rest: "shadow-[inset_0_0_0_var(--fw-border-sm)_var(--fw-color-border-subtle)] group-active:shadow-[inset_0_0_0_var(--fw-border-lg)_var(--fw-color-border-strong)]",
        },
      },
    },
  ),
  badge:
    "absolute -top-[var(--fw-space-gap-xxs)] -right-[var(--fw-space-gap-xxs)] flex items-center justify-center rounded-[var(--fw-radius-full)] bg-[var(--fw-color-content-neutral-secondary)] text-[var(--fw-color-content-neutral-inverse)]",
  title: cva("fw-l1 max-w-full truncate", {
    variants: {
      state: {
        disabled: "text-[var(--fw-color-content-neutral-disabled)]",
        selected: "text-[var(--fw-color-content-neutral-primary)]",
        rest: "text-[var(--fw-color-content-neutral-tertiary)]",
      },
    },
  }),
};
